import { create } from 'zustand';

interface DemoState {
  demoExpired: boolean;
  demoAccessUntil: string | null;
  setDemoExpired: (value: boolean) => void;
  setDemoAccessUntil: (value: string | null) => void;
}

const useDemoStore = create<DemoState>((set) => ({
  demoExpired: false,
  demoAccessUntil: null,
  setDemoExpired: (value) => set({ demoExpired: value }),
  setDemoAccessUntil: (value) => set({ demoAccessUntil: value }),
}));

export default useDemoStore;
